module.exports = __webpack_public_path__ + "img/lunar.92c49cb8.svg";